/** @jsxRuntime classic */
/** @jsx jsx */
import { Text } from '@bottlebooks/gatsby-design-system';
import { Link } from '@bottlebooks/gatsby-theme-base/src';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { LinkedinLogo } from 'phosphor-react';
import { jsx } from 'theme-ui';
import Skeleton from '../Skeleton';
import type { TextProps } from './UserProfileCard';
import { gql } from '@apollo/client';

export default function UserProfileCardLinkedIn({
  profile,
  ...rest
}: TextProps & { profile: UserProfileCardLinkedInData }) {
  if (!profile?.linkedInURL) return null;
  return (
    <Text variant="smallest" sx={{ color: 'lighterText' }} {...rest}>
      <Link
        href={profile.linkedInURL}
        target="_blank"
        rel="noopener noreferrer"
        variant="text"
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <LinkedinLogo size={20} weight="fill" />
        <Trans>See on LinkedIn</Trans>
      </Link>
    </Text>
  );
}

export const fragment = graphql`
  fragment UserProfileCardLinkedIn on Bottlebooks_SiteUserProfile {
    linkedInURL
  }
`;

UserProfileCardLinkedIn.fragment = gql`
  fragment UserProfileCardLinkedIn on SiteUserProfile {
    linkedInURL
  }
`;

export type UserProfileCardLinkedInData = {
  linkedInURL: string | null;
};

export function UserProfileCardLinkedInSkeleton(rest: TextProps) {
  return (
    <Text variant="smallest" {...rest}>
      <Skeleton width="4em" height="1em" />
    </Text>
  );
}
